<template>
  <b-modal
    ref="order-history-modal"
    v-model="showModal"
    size="xl"
    :title="`Chi tiết lịch sử đơn hàng - ${id || ''}`"
    header-bg-variant="light"
    @hidden="onModalHidden"
    @show="onModalShow"
    no-close-on-backdrop
    scrollable
  >
    <b-overlay :show="isLoading" rounded="sm">
      <div v-if="!isLoading && historyData">
        <h5 class="bold-text">Thông tin log</h5>
        <hr />

        <b-container class="bv-example-row">
          <b-row class="justify-content-md-center mb-10">
            <b-col>
              <b-row>
                <b-col class="col-md-3">
                  <p class="header-color">Loại log:</p>
                  <p class="header-color">Mã:</p>
                </b-col>
                <b-col>
                  <p>{{ historyData.type }}</p>
                  <p>{{ historyData.id }}</p>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <b-row>
                <b-col class="col-md-3">
                  <p class="header-color">Người sửa:</p>
                  <p class="header-color">IP:</p>
                </b-col>
                <b-col>
                  <p>
                    <b>{{ historyData.updatedBy }}</b>
                  </p>
                  <p>{{ historyData.clientIp }}</p>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <b-row>
                <b-col class="col-md-3">
                  <p class="header-color">Cửa hàng:</p>
                </b-col>
                <b-col>
                  <p>{{ historyData.storeName }}</p>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-container>

        <h5 class="bold-text">Thông tin thay đổi</h5>
        <hr />
        <b-container class="bv-example-row">
          <table
            border="1"
            style="width: 60%"
            class="table table-bordered table-vertical-center table-hover mb-10"
          >
            <colgroup>
              <col style="width: 20%" />
              <col style="width: 40%" />
              <col style="width: 40%" />
            </colgroup>
            <thead class="bg-secondary">
              <tr>
                <th rowspan="2">Thông tin trên phiếu</th>
              </tr>
              <tr>
                <th>Trước khi sửa</th>
                <th>Sau khi sửa</th>
              </tr>
            </thead>
            <tbody v-if="hasDiffInfo">
              <tr
                v-if="
                  historyData.diffInfo._.customerNote &&
                    isModified(historyData.diffInfo._.customerNote)
                "
              >
                <th class="header-color">Ghi chú khách hàng</th>
                <td>
                  {{
                    historyData.diffInfo._.customerNote
                      ? historyData.diffInfo._.customerNote.original
                      : ''
                  }}
                </td>
                <td>
                  {{
                    historyData.diffInfo._.customerNote
                      ? historyData.diffInfo._.customerNote.current
                      : ''
                  }}
                </td>
              </tr>
              <tr v-if="isAdded(historyData.diffInfo._.customerNote)">
                <th class="header-color">Ghi chú khách hàng</th>
                <td></td>
                <td>
                  {{
                    historyData.diffInfo._.customerNote
                      ? historyData.diffInfo._.customerNote.current
                      : ''
                  }}
                </td>
              </tr>
              <tr
                v-if="isModified(historyData.diffInfo._.cashAccountId.status)"
              >
                <th class="header-color">Tài khoản thanh toán</th>
                <td>{{ historyData.diffInfo._.cashAccountId.original }}</td>
                <td>{{ historyData.diffInfo._.cashAccountId.current }}</td>
              </tr>
              <tr v-if="isAdded(historyData.diffInfo._.cashAccountId.status)">
                <th class="header-color">Tài khoản thanh toán</th>
                <td></td>
                <td>{{ historyData.diffInfo._.cashAccountId.current }}</td>
              </tr>
              <tr v-if="isModified(historyData.diffInfo._.checkDate.status)">
                <th class="header-color">Ngày đến cửa hàng</th>
                <td>{{ historyData.diffInfo._.checkDate.original }}</td>
                <td>{{ historyData.diffInfo._.checkDate.current }}</td>
              </tr>
              <tr v-if="isAdded(historyData.diffInfo._.checkDate.status)">
                <th class="header-color">Ngày đến cửa hàng</th>
                <td></td>
                <td>{{ historyData.diffInfo._.cashAccountId.current }}</td>
              </tr>
              <tr v-if="isModified(historyData.diffInfo._.checkTime.status)">
                <th class="header-color">Giờ đến cửa hàng</th>
                <td>{{ historyData.diffInfo._.checkTime.original }}</td>
                <td>{{ historyData.diffInfo._.checkTime.current }}</td>
              </tr>
              <tr v-if="isAdded(historyData.diffInfo._.checkTime.status)">
                <th class="header-color">Giờ đến cửa hàng</th>
                <td></td>
                <td>{{ historyData.diffInfo._.checkTime.current }}</td>
              </tr>
              <tr v-if="isModified(historyData.diffInfo._.codeShip.status)">
                <th class="header-color">Mã vận đơn</th>
                <td>{{ historyData.diffInfo._.codeShip.original }}</td>
                <td>{{ historyData.diffInfo._.codeShip.current }}</td>
              </tr>
              <tr v-if="isAdded(historyData.diffInfo._.codeShip.status)">
                <th class="header-color">Mã vận đơng</th>
                <td></td>
                <td>{{ historyData.diffInfo._.codeShip.current }}</td>
              </tr>
              <tr
                v-show="
                  isModified(historyData.diffInfo._.customerShipFee.status)
                "
              >
                <th class="header-color">Phí vận chuyển thu của khách</th>
                <td>{{ historyData.diffInfo._.customerShipFee.original }}</td>
                <td>{{ historyData.diffInfo._.customerShipFee.current }}</td>
              </tr>
              <tr v-if="isAdded(historyData.diffInfo._.customerShipFee.status)">
                <th class="header-color">Phí vận chuyển thu của khách</th>
                <td></td>
                <td>{{ historyData.diffInfo._.customerShipFee.current }}</td>
              </tr>
              <tr
                v-if="isModified(historyData.diffInfo._.depositAmount.status)"
              >
                <th class="header-color">Tiền đặt cọc</th>
                <td>{{ historyData.diffInfo._.depositAmount.original }}</td>
                <td>{{ historyData.diffInfo._.depositAmount.current }}</td>
              </tr>
              <tr v-if="isAdded(historyData.diffInfo._.depositAmount.status)">
                <th class="header-color">Tiền đặt cọc</th>
                <td></td>
                <td>{{ historyData.diffInfo._.customerShipFee.current }}</td>
              </tr>
              <tr
                v-if="isModified(historyData.diffInfo._.discountAmount.status)"
              >
                <th class="header-color">Chiết khấu</th>
                <td>{{ historyData.diffInfo._.discountAmount.original }}</td>
                <td>{{ historyData.diffInfo._.discountAmount.current }}</td>
              </tr>
              <tr v-if="isAdded(historyData.diffInfo._.discountAmount.status)">
                <th class="header-color">Chiết khấu</th>
                <td></td>
                <td>{{ historyData.diffInfo._.discountAmount.current }}</td>
              </tr>
              <tr v-if="isModified(historyData.diffInfo._.discountType.status)">
                <th class="header-color">Kiểu chiết khấu</th>
                <td>{{ historyData.diffInfo._.discountType.original }}</td>
                <td>{{ historyData.diffInfo._.discountType.current }}</td>
              </tr>
              <tr v-if="isAdded(historyData.diffInfo._.discountType.status)">
                <th class="header-color">Kiểu chiết khấu</th>
                <td></td>
                <td>{{ historyData.diffInfo._.discountType.current }}</td>
              </tr>
              <tr
                v-if="isModified(historyData.diffInfo._.orderSourceId.status)"
              >
                <th class="header-color">Nguồn đơn hàng</th>
                <td>{{ historyData.diffInfo._.orderSourceId.original }}</td>
                <td>{{ historyData.diffInfo._.orderSourceId.current }}</td>
              </tr>
              <tr v-if="isAdded(historyData.diffInfo._.orderSourceId.status)">
                <th class="header-color">Nguồn đơn hàng</th>
                <td></td>
                <td>{{ historyData.diffInfo._.orderSourceId.current }}</td>
              </tr>
              <tr v-if="isModified(historyData.diffInfo._.orderType?.status)">
                <th class="header-color">Loại đơn</th>
                <td>{{ historyData.diffInfo._.orderType?.original }}</td>
                <td>{{ historyData.diffInfo._.orderType?.current }}</td>
              </tr>
              <tr v-if="isAdded(historyData.diffInfo._.orderType?.status)">
                <th class="header-color">Loại đơn</th>
                <td></td>
                <td>{{ historyData.diffInfo._.orderType?.current }}</td>
              </tr>
              <tr v-if="isModified(historyData.diffInfo._.paymentDate.status)">
                <th class="header-color">Ngày hẹn thanh toán</th>
                <td>{{ historyData.diffInfo._.paymentDate.original }}</td>
                <td>{{ historyData.diffInfo._.paymentDate.current }}</td>
              </tr>
              <tr v-if="isAdded(historyData.diffInfo._.paymentDate.status)">
                <th class="header-color">Ngày hẹn thanh toán</th>
                <td></td>
                <td>{{ historyData.diffInfo._.paymentDate.current }}</td>
              </tr>
              <tr v-if="isModified(historyData.diffInfo._.saleNote.status)">
                <th class="header-color">Ghi chú CSKH</th>
                <td>{{ historyData.diffInfo._.saleNote.original }}</td>
                <td>{{ historyData.diffInfo._.saleNote.current }}</td>
              </tr>
              <tr v-if="isAdded(historyData.diffInfo._.saleNote.status)">
                <th class="header-color">Ghi chú CSKH</th>
                <td></td>
                <td>{{ historyData.diffInfo._.saleNote.current }}</td>
              </tr>
              <tr v-if="isModified(historyData.diffInfo._.shipFee.status)">
                <th class="header-color">Phí trả HVC</th>
                <td>{{ historyData.diffInfo._.shipFee.original }}</td>
                <td>{{ historyData.diffInfo._.shipFee.current }}</td>
              </tr>
              <tr v-if="isAdded(historyData.diffInfo._.shipFee.status)">
                <th class="header-color">Phí trả HVC</th>
                <td></td>
                <td>{{ historyData.diffInfo._.shipFee.current }}</td>
              </tr>
              <tr v-if="isModified(historyData.diffInfo._.status.status)">
                <th class="header-color">Trạng thái đơn</th>
                <td>{{ historyData.diffInfo._.statusName.original }}</td>
                <td>{{ historyData.diffInfo._.statusName.current }}</td>
              </tr>
              <tr v-if="isAdded(historyData.diffInfo._.status.status)">
                <th class="header-color">Trạng thái đơn</th>
                <td></td>
                <td>{{ historyData.diffInfo._.status.current }}</td>
              </tr>
              <tr v-if="isModified(historyData.diffInfo._.storeId.status)">
                <th class="header-color">Cửa hàng</th>
                <td>{{ historyData.diffInfo._.storeId.original }}</td>
                <td>{{ historyData.diffInfo._.storeId.current }}</td>
              </tr>
              <tr v-if="isAdded(historyData.diffInfo._.storeId.status)">
                <th class="header-color">Cửa hàng</th>
                <td></td>
                <td>{{ historyData.diffInfo._.storeId.current }}</td>
              </tr>
              <tr
                v-if="
                  isModified(historyData.diffInfo._.transferAccountId.status)
                "
              >
                <th class="header-color">Tài khoản chuyển khoản</th>
                <td>{{ historyData.diffInfo._.transferAccountId.original }}</td>
                <td>{{ historyData.diffInfo._.transferAccountId.current }}</td>
              </tr>
              <tr
                v-if="isAdded(historyData.diffInfo._.transferAccountId.status)"
              >
                <th class="header-color">Tài khoản chuyển khoản</th>
                <td></td>
                <td>{{ historyData.diffInfo._.transferAccountId.current }}</td>
              </tr>
              <tr
                v-if="isModified(historyData.diffInfo._.transferAmount.status)"
              >
                <th class="header-color">Tiền chuyển khoản</th>
                <td>{{ historyData.diffInfo._.transferAmount.original }}</td>
                <td>{{ historyData.diffInfo._.transferAmount.current }}</td>
              </tr>
              <tr v-if="isAdded(historyData.diffInfo._.transferAmount.status)">
                <th class="header-color">Tiền chuyển khoản</th>
                <td></td>
                <td>{{ historyData.diffInfo._.transferAmount.current }}</td>
              </tr>
            </tbody>
          </table>
        </b-container>

        <h5 class="bold-text">Chi tiết thay đổi sản phẩm</h5>
        <hr />
        <b-container class="bv-example-row">
          <table
            class="table table-bordered table-vertical-center table-hover mb-10"
          >
            <tr>
              <th style="width: 50%">Trước</th>
              <th>Sau</th>
            </tr>
            <tr
              v-for="(item, index) in hasDiffItem ? historyData.diffItem._ : []"
              :key="index"
            >
              <td>
                <div
                  v-if="item.status === 'ADDED'"
                  v-show="item.status === 'ADDED'"
                >
                  <span>{{ item.original }}</span>
                </div>

                <div>
                  <span
                    v-if="item.status === 'MODIFIED'"
                    v-show="item.status === 'MODIFIED'"
                  >
                    <p class="text-primary header-color">
                      {{ item._.productName.original }}
                    </p>
                    <b-row>
                      <b-col class="col col-sm-3">
                        <p class="header-color">ID sản phẩm:</p>
                        <p class="header-color">Imei:</p>
                        <p class="header-color">Giá:</p>
                        <p class="header-color">Số lượng:</p>
                        <p class="header-color">Chiết khấu:</p>
                      </b-col>
                      <b-col>
                        <p>{{ item._.productId.original || 0 }}</p>
                        <p>
                          {{
                            item._.imeiCode.original !== ''
                              ? item._.imeiCode.current
                              : 0
                          }}
                        </p>
                        <p>
                          {{ convertPrice(item._.productPrice.original) }}
                        </p>
                        <p>{{ item._.quantity.original }}</p>
                        <p>{{ item._.discountAmount.original }}</p>
                      </b-col>
                    </b-row>
                  </span>
                </div>
              </td>

              <td>
                <div
                  v-if="item.status === 'ADDED'"
                  v-show="item.status === 'ADDED'"
                >
                  <p class="text-primary header-color">
                    {{ item.current.productName }}
                  </p>
                  <b-row>
                    <b-col class="col col-sm-3">
                      <p class="header-color">ID sản phẩm:</p>
                      <p class="header-color">Imei:</p>
                      <p class="header-color">Giá:</p>
                      <p class="header-color">Số lượng:</p>
                      <p class="header-color">Chiết khấu:</p>
                    </b-col>
                    <b-col>
                      <p>{{ item.current.productId }}</p>
                      <p>
                        {{
                          item.current.imeiCode !== ''
                            ? item.current.imeiCode
                            : 0
                        }}
                      </p>
                      <p>{{ convertPrice(item.current.productPrice) }}</p>
                      <p>{{ item.current.quantity }}</p>
                      <p>{{ item.current.discountAmount }}</p>
                    </b-col>
                  </b-row>
                </div>

                <div>
                  <span
                    v-if="item.status === 'MODIFIED'"
                    v-show="
                      item.status === 'MODIFIED' &&
                        item._.deleted.status === 'EQUAL'
                    "
                  >
                    <p class="text-primary header-color">
                      {{ item._.productName.current }}
                    </p>
                    <b-row>
                      <b-col class="col col-sm-3">
                        <p class="header-color">ID sản phẩm:</p>
                        <p class="header-color">Imei:</p>
                        <p class="header-color">Giá:</p>
                        <p class="header-color">Số lượng:</p>
                        <p class="header-color">Chiết khấu:</p>
                      </b-col>
                      <b-col>
                        <p>{{ item._.productId.current }}</p>
                        <p>{{ item._.imeiCode.current || 0 }}</p>
                        <p>
                          {{ convertPrice(item._.productPrice.current) }}
                        </p>
                        <p>{{ item._.quantity.current }}</p>
                        <p>{{ item._.discountAmount.current }}</p>
                      </b-col>
                    </b-row>
                  </span>
                </div>
              </td>
            </tr>
          </table>
        </b-container>
      </div>
    </b-overlay>

    <template #modal-footer="{ close }">
      <b-button variant="secondary" size="sm" @click="close()">
        Đóng
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import ApiService from '@/core/services/api.service';

export default {
  name: 'OrderHistoryModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    historyId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      showModal: false,
      isLoading: false,
      historyData: null,
      id: '',
    };
  },
  computed: {
    hasDiffInfo() {
      return (
        this.historyData &&
        this.historyData.diffInfo &&
        this.historyData.diffInfo._
      );
    },
    hasDiffItem() {
      return (
        this.historyData &&
        this.historyData.diffItem &&
        this.historyData.diffItem._
      );
    },
  },
  watch: {
    show(newVal) {
      this.showModal = newVal;
      if (newVal && this.historyId) {
        this.loadHistoryData();
      }
    },
    showModal(newVal) {
      this.$emit('update:show', newVal);
      if (newVal) {
        this.updateUrlWithModal();
      } else {
        this.removeUrlModal();
      }
    },
  },
  mounted() {
    this.handleModalFromUrl();

    window.addEventListener('popstate', this.handlePopState);

    document.addEventListener('keydown', this.handleEscKey);
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.handlePopState);
    document.removeEventListener('keydown', this.handleEscKey);
  },
  methods: {
    async loadHistoryData() {
      if (!this.historyId) return;

      this.isLoading = true;
      this.id = this.historyId;

      try {
        const params = { type: 1 };
        const response = await ApiService.query(
          `/v1/histories/${this.historyId}`,
          { params },
        );

        const {
          type,
          createdByName,
          storeName,
          diffInfo,
          diffItem,
          clientIp,
        } = response.data.data;

        this.historyData = {
          type: this.getHistoryType(type),
          id: this.historyId,
          updatedBy: createdByName,
          storeName,
          clientIp,
          diffInfo,
          diffItem,
        };
      } catch (error) {
        console.error('Error loading history data:', error);
      } finally {
        this.isLoading = false;
      }
    },

    convertPrice(number) {
      const result = new Intl.NumberFormat('vn-VN').format(number);
      return isNaN(parseFloat(result)) ? '' : result;
    },

    isModified(value) {
      return value === 'MODIFIED';
    },

    isAdded(value) {
      return value === 'ADDED';
    },

    getHistoryType(typeId) {
      switch (typeId) {
        case 1:
          return 'Đơn hàng';
        case 2:
          return 'Hóa đơn';
        default:
          return '';
      }
    },

    onModalShow() {
      this.$emit('show');
    },

    onModalHidden() {
      this.$emit('hidden');
      this.removeUrlModal();
    },

    updateUrlWithModal() {
      if (this.historyId) {
        const currentUrl = new URL(window.location);
        currentUrl.searchParams.set('modal', 'order-history');
        currentUrl.searchParams.set('id', this.historyId);
        window.history.pushState(null, '', currentUrl.toString());
      }
    },

    removeUrlModal() {
      const currentUrl = new URL(window.location);
      currentUrl.searchParams.delete('modal');
      currentUrl.searchParams.delete('id');
      window.history.replaceState(null, '', currentUrl.toString());
    },

    handleModalFromUrl() {
      const urlParams = new URLSearchParams(window.location.search);
      const modal = urlParams.get('modal');
      const historyId = urlParams.get('id');

      if (modal === 'order-history' && historyId) {
        this.$emit('open-modal', historyId);
      }
    },

    handlePopState() {
      const urlParams = new URLSearchParams(window.location.search);
      const modal = urlParams.get('modal');

      if (modal !== 'order-history' && this.showModal) {
        this.showModal = false;
      }
    },

    handleEscKey(event) {
      if (event.key === 'Escape' && this.showModal) {
        this.showModal = false;
      }
    },
  },
};
</script>

<style scoped>
.header-color {
  font-weight: 500;
}

.bold-text {
  color: #212121;
}

.mb-10 {
  margin-bottom: 1rem;
}

.bv-example-row {
  margin-bottom: 1rem;
}
</style>
